import v5_Model from '@/models/v5/model';

var model = v5_Model.extend({
    initialize: function() {
        this.type = model.type;
    }
});
model.type = 'webhook';
export default model;

